import { z } from 'zod';
/**
 * Skill `templates` (Paket I, Issue #100).
 *
 * Projekt-Vorlagen — wiederverwendbare fachliche Daten-Blueprints (z. B. für
 * typische Wohnanlagen GKL 3, Versammlungsstaetten, Kindergaerten). Werden in
 * Wizards/Cloning genutzt, um Default-Werte zu setzen.
 */
export const createTemplateRequest = z
    .object({
    name: z.string().min(2).max(120),
    description: z.string().max(1000).optional(),
    buildingType: z.string().max(80).optional(),
    buildingClass: z.string().max(40).optional(),
    data: z.record(z.unknown()),
})
    .strict();
export const updateTemplateRequest = createTemplateRequest.partial();
export const listTemplatesQuery = z
    .object({
    archived: z.coerce.boolean().optional(),
})
    .strict();
